import { render, staticRenderFns } from "./Births.vue?vue&type=template&id=e0140af0"
import script from "./Births.vue?vue&type=script&lang=js"
export * from "./Births.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports